import { IconUsers } from '@tabler/icons-react'
import uniqBy from 'lodash/uniqBy'

import { dispatchSuccessToast } from '~/store/slices/toasterSlice'

import { withFieldGroup } from '../../Form/formHooks'
import type { FormPractitionerProfile, FormProfileSurgeryTypeGroup } from './formState'
import { SurgeryTypeFormSelect } from './SurgeryTypeFormSelect'

const defaultValues: FormPractitionerProfile = {
    mainSurgeryTypeGroups: [],
    inTrainingSurgeryTypeGroups: [],
} as const
export const SurgeryTypeGroupFields = withFieldGroup({
    defaultValues,
    render: function Render({ group }) {
        const handleMoveFromTrainingToMain = (value: FormProfileSurgeryTypeGroup[]) => {
            const codesToUpdate = new Set(value.map(v => v.surgeryTypeGroup.code))
            group.setFieldValue('mainSurgeryTypeGroups', prev => uniqBy([...prev, ...value], v => v.surgeryTypeGroup.code))
            group.setFieldValue('inTrainingSurgeryTypeGroups', prev => prev.filter(v => !codesToUpdate.has(v.surgeryTypeGroup.code)))

            const nameMessage = value.length > 1 ? 'gruppen' : <i>{value.at(0)?.surgeryTypeGroup.displayName ?? 'operasjonskategorien'}</i>
            dispatchSuccessToast(<>Flyttet {nameMessage} til hovedoperatør</>)
        }

        return (
            <div className="flex flex-col gap-3">
                <group.AppField name="mainSurgeryTypeGroups">
                    {field => (
                        <SurgeryTypeFormSelect label="Hovedoperatør" value={field.state.value} onChange={field.handleChange} errors={field.state.meta.errors} />
                    )}
                </group.AppField>
                <group.AppField name="inTrainingSurgeryTypeGroups">
                    {field => (
                        <SurgeryTypeFormSelect
                            label="Assistent"
                            icon={IconUsers}
                            value={field.state.value}
                            onChange={field.handleChange}
                            errors={field.state.meta.errors}
                            onMove={handleMoveFromTrainingToMain}
                        />
                    )}
                </group.AppField>
            </div>
        )
    },
})
